import { StyledAnchors } from '@/components/styles';
import Swiper from 'react-id-swiper';

export default function Anchors({ list = [], handleClick, active, slider, params, activeThumb, type, arrow = 'right', remountKey }) {
  return (
    <StyledAnchors type={type}>
      {slider ? (
        <Swiper key={remountKey} {...params} shouldSwiperUpdate>
          {list.map((item, ind) => {
            const { title, id } = item;
            const onClick = (e) => {
              handleClick && handleClick(ind);
            };
            return (
              <StyledAnchors.Item key={id} as="p" id={`anchor-${id}`}>
                <StyledAnchors.Link onClick={onClick} as="span" active={activeThumb === ind}>
                  {title}
                </StyledAnchors.Link>
              </StyledAnchors.Item>
            );
          })}
        </Swiper>
      ) : (
        <>
          {list.map((item) => {
            const { title, id, slug } = item;

            const onClick = (e) => {
              e.preventDefault();
              if (slug) {
                handleClick && handleClick(slug);
              } else {
                handleClick && handleClick(id);
              }
            };

            return (
              <StyledAnchors.Item key={id}>
                <StyledAnchors.Link href={`#${id}`} onClick={onClick} isActive={active == slug} arrow={arrow}>
                  {title}
                </StyledAnchors.Link>
              </StyledAnchors.Item>
            );
          })}
        </>
      )}
    </StyledAnchors>
  );
}
